import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import { BPost } from '../models/b-post.model';
import { BImage } from '../models/bimage.model';
import { BComment } from '../models/b-comment.model';
@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }

  // Enregistrement d'un article
  saveArticle(article: BPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/b_post`, article, {'headers': headers});
  }

  getAllArticles1(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_post/connected`, {'headers': headers});
  }

  // Récupérer la liste des articles
  getAllArticles(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_post`, {'headers': headers});
  }

  // Liste des articles publiés par catégorie
  getPublishArticleByCategory(idC: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_post/category/`+idC, {'headers': headers});
  }

  // Publié un article
  publishArticle(article: BPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_post/publish/` + article.id, {'headers': headers});
  }

  // Modifié un article
  updateArticle(article: BPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_post/` + article.id, article, {'headers': headers});
  }


  getArticleById(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_post/` + idA, {'headers': headers});
  }

  deleteArticle(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/b_post/` + idA, {'headers': headers});
  }

  saveImage(image: BImage) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/b_image`, image, {'headers': headers});
  }

  getAllImages(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_image`, {'headers': headers});
  }

  updateImage(image: BImage) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_image/` + image.id, image, {'headers': headers});
  }

  deletePhoto(idImg: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/b_image/` + idImg, {'headers': headers});
  }

  //api/b_comment/publish/{id}
  publishComment(b_comment: BComment) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_comment/publish/` + b_comment.id, b_comment, {'headers': headers});
  }
  //api/b_comment
  loadComment(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_comment/all`, {'headers': headers});
  }

  deleteComment(idC: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/b_comment/` + idC, {'headers': headers});
  }

  //api/b_comment/disactive/{id}
  disableComment(b_comment: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_comment/disactive/` + b_comment.id, {'headers': headers});
  }

  //api/b_post/disactive/{id}
  disablePublishArticle(b_post: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/b_post/disactive/` + b_post.id, {'headers': headers});
  }

  //b_comment/post/all/{id}
  allCommentsByPost(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/b_comment/post/all/` + id, {'headers': headers});
  }

  //api/b_comment/post/light/{id}
  // allCommentsByPost(id: number): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  //   return this.http.get<any>(`${environment.url}/b_comment/post/light/` + id, {'headers': headers});
  // }


}
